<template>
    <div class="info-box-rd-nummer">
        <div class="mx-4 py-3 d-flex flex-row align-items-center flex-wrap flex-md-nowrap">
            <span class="ms-2 me-3">
                <info_icon></info_icon>
            </span>
            <div class="ms-2 me-3">
                <b>RD-Nummer: {{ rdnummer }} hinterlegt.</b>
            </div>
            <button 
                v-if="isSchritt0"
                type="button"
                class="btn rd-nummer-aendern-button rounded rounded-pill px-3 d-flex align-items-center whitespace-nowrap text-nowrap flex-nowrap mt-2 mt-md-0"
                @click="removeRdNummer"
            >
                entfernen 
                <span class="ms-3 mb-1">
                    <kreuz_icon></kreuz_icon>
                </span>
            </button>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRechnerStore } from '@/stores/rechner';
import info_icon from '@/components/icons/info_icon.vue';
import kreuz_icon from '@/components/icons/kreuz_icon_fff.vue';

const store = useRechnerStore();

defineProps({
    rdnummer: {
        type: [String, Number],
        required: true
    }
});

// Prüft, ob wir in Schritt 1 sind
const isSchritt0 = computed(() => store.stepStatus === 0);

// RD-Nummer aus dem Store entfernen
const removeRdNummer = () => {
    store.aok = 0;
    store.aokName = '';
};
</script>

<style scoped>
.info-box-rd-nummer {
    width:fit-content;
}
</style>